export default class UrlMaker {
    static install = (Vue, env) => {
        Object.defineProperty(Vue.prototype, '$invokeUrlMaker', {
            get() {
                return this.$root._invokeUrlMaker;
            }
        });

        Vue.mixin({
            beforeCreate() {
                if (!this.$root._invokeUrlMaker) {
                    this.$root._invokeUrlMaker = new UrlMaker(env);
                }
            }
        });
    };

    /**
     * @constructor
     * @param env
     */
    constructor(env) {
        this.baseUrl_ = env.API.INVOKE_URL;
    }

    /**
     * @constructor
     * @param env
     */
    create(path) {
        return `${process.env.API.INVOKE_URL}${path}`;
    }
};



// WEBPACK FOOTER //
// ./src/custom_plugins/invoke/url_maker.js